export const dayjsFormat = {
  default: 'M월 D일 h:mm A',
  withYear: 'YYYY년 MM월 DD일 hh:mm A',
  yearMonthDay: 'YYYY. MM. DD.',
  yearMonthDay2: 'YYYY.MM.DD',
  yearMonthDay3: 'YYYY년 M월 D일',
  yearMonthDayDayOfTheWeek: 'YYYY. MM. DD. dd',
  hourMinute: 'h:mm A',
  leadingZeriHourMinute: 'HH:mm A',
  yearMonthDayWithMinute: 'YYYY. MM. DD. hh:mm A',
} as const;
